import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { goodsTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { Departments } from '@/types';
import { toasts } from '@/utils/toasts';

export const editGoodsItem = (data: goodsTypes.EditItemData) => {
  const { _id, ...dataWithoutId } = data;
  return axios.patch(`/goods/${_id}`, { data: dataWithoutId });
};

type EditGoodsItemOptions = {
  department: Departments;
  onSuccess: () => void;
  config?: MutationConfig<typeof editGoodsItem>;
};

export function useEditGoodsItem({ config = {}, department, onSuccess }: EditGoodsItemOptions) {
  return useMutation({
    ...config,
    onSuccess: () => {
      queryClient.invalidateQueries(['goods', department]);
      toasts.loadingToast.success('edit-goods-item', 'Goods item updated successfully');
      onSuccess();
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error('edit-goods-item', serverMessage);
      config.onError?.(error, ...args);
    },
    onMutate: (...args) => {
      toasts.loadingToast.loading('edit-goods-item', 'Updating goods item...');
      config.onMutate?.(...args);
    },
    mutationFn: editGoodsItem,
  });
}
